import { INVOICES } from '../actionTypes';

export const fetchInvoices = (payload) => ({
  type: INVOICES.FETCH,
  payload,
});

export const updatePartialPayment = (action) => ({
  type: INVOICES.UPDATE,
  payload: action.payload,
});
